<div class="content">
  <h1 class="title">Kontingentsatser</h1>

  <p class="intro-text">Månedlig kontingent for yrkesaktive medlemmer er 1,2 prosent av brutto månedslønn.</p>

  <p>
    I tillegg kommer obligatoriske forsikringer og bidrag til Fagforbundets opplærings- utviklings- og omstillingsfond.
    Satsene for {{ thisYear }} er:
  </p>

  <dl class="fees">
    <div class="fee-row">
      <dt>LOfavør Innboforsikring</dt>
      <dd>kr. 105,00 per måned</dd>
    </div>

    <div class="fee-row">
      <dt>Fagforbundets stønadskasse</dt>
      <dd>kr. 32,00 per måned</dd>
    </div>

    <div class="fee-row">
      <dt>Opplærings- utviklings- og omstillingsfondet</dt>
      <dd>kr. 37,00 per måned</dd>
    </div>

    <div class="fee-row fee-row-total">
      <dt>Til sammen</dt>
      <dd>kr. 174,00 per måned</dd>
    </div>
  </dl>
  <div class="footnote">* eller kr. 69,00 per måned for de som har reservert seg mot innboforsikringen</div>

  <h2 class="max-title">Maksimumskontingent</h2>

  <p>
    Det er fastsatt en øvre grense for kontingentens størrelse. For {{ thisYear }} er denne grensen kr 681,00 per måned
    (i tillegg kommer innboforsikring, stønadskasse og OUO-kont.)
  </p>

  <p class="text-bold">
    Maksimalt samlet trekk vil være kr 681,00 ,- (kontingent) + kr 174,00 ,- (forsikring OUO) = kr 855,00
  </p>

  <p class="text-bold">
    <span>Trukket kontingent innbetales til kontonummer</span>&nbsp;
    <span>9001.05.37303</span>
  </p>

  <p class="link">
    Enkelte av Fagforbundets lokale fagforeninger har imidlertid vedtatt en lokal tilleggskontingent for å dekke sine
    utgifter, og da blir også maksimumsbeløpet tilsvarende høyere. Har du en lokal tilleggskontigent?
    <a routerLink="/deduction-rates/local"> Sjekk ditt prosenttrekk her </a>
  </p>
</div>
